/**
 * @prettier
 */

export const KEY_NAME = 'customAlertShown';

export function getIsCustomAlertBeingShownInLocalStorage(): boolean {
    return window.localStorage.getItem(KEY_NAME) === 'true';
}
